'use client';
import { lazy, Suspense, forwardRef, useRef, type ComponentProps, type ComponentRef } from 'react';
export type * from "/tmp/build-258/node_modules/@eliadmin/core/src/components/auth/password-reset-form.tsx";

type Props = NonNullable<ComponentProps<typeof import("/tmp/build-258/node_modules/@eliadmin/core/src/components/auth/password-reset-form.tsx").ForgotPasswordForm>>;
const Deferred = lazy(() => import("@eliadmin/module-original/forgotPasswordForm").then(m => ({ default: m.ForgotPasswordForm })));
export function ForgotPasswordForm(props: Props) {  return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }

